export function canHandleTelLinks(): boolean {
  const a = document.createElement('a');
  a.href = 'tel:123';
  return a.protocol === 'tel:';
}
